import React from 'react';

import { EventPerformance, Review, timeData } from '../../models/models';

import config from '../../config/config';
import MiniEventDetail from './mini-event-detail';
import VerticalEventDetail from './vertical-event-detail';
import Gallery from '../gallery/gallery';
import MediaViewer from '../media-viewer/media-viewer';

import { ModalContext } from '../modal/modal';
import ReviewComponent from '../review/review';
import ReviewForm from '../review/review-form';
import MiniMediaViewer from '../media-viewer/mini-media-viewer';
import Gallery3 from '../gallery/gallery3';
import Gallery2 from '../gallery/gallery2';

import HttpService from '../../services/http.service';

const acceptedMedia = [
  'gif', 'jpg', 'jpeg', 'png',
  'mov', 'mp4', 'mpeg', 'webm', 'ogg'
];

const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;

const periodPrases = (e: EventPerformance): string => {
  let { year, month, day, period } = (e as EventPerformance);
  const dayNum = (new Date(year, months.indexOf(month), day)).getDay();
  const weekday: typeof weekdays[number] = weekdays[dayNum];
  const dayCount = Math.floor((day-1) / 7) + 1;
  const dayCountSuffix = [ 'st', 'nd', 'rd', 'th', 'th' ];
  return ({
    Once: ``,
    Daily: `Every day`,
    Weekly: `Every ${weekday}`,
    BiWeekly: `Every other ${weekday}`,
    Monthly: `The ${dayCount}${dayCountSuffix[dayCount-1]} ${weekday} of every month`
  })[period];
};

type EventListItemProps = {
  event: EventPerformance;
}

const EventFull: React.FC<EventListItemProps> = ({ event }) => {

  const modalContext = React.useContext(ModalContext);

  const [eventReviews, setEventReviews] = React.useState<Review[]>([]);

  React.useEffect(() => {
    (async () => {
      const revRes = await HttpService.get<Review[]>('reviewstream', { numrows: 20, afterID: 0, event: event.id });
      if (revRes.success && revRes.body) {
        setEventReviews(revRes.body);
      }
    })();
  }, []);

  return (
    <div className="mx-auto my-6  bg-gradient-to-br from-pink-200 via-pink-300 to-pink-200 rounded-lg">          
      <div  className="border-gray-200 rounded p-1 shadow-2xl">
        <div className="hidden md:block"><MiniEventDetail event={event} /></div>
        <div className="md:hidden"><VerticalEventDetail event={event} /></div>
        
        {
          !!event.media?.length &&
            <div className="p-4 rounded shadow-md bg-gradient-to-br from-fuchsia-100 via-fuchsia-200 to-fuchsia-100">
              <h1 className="p-4">Media for this event</h1>
              <Gallery3>
                {
                  event.media.map((a, i) => (
                    <span 
                      key={i} 
                      className="relative inline-block cursor-pointer"
                      onClick={() => {
                        (new Promise<any>((res, rej) => {
                          modalContext.modal!({
                            node: (<MediaViewer filename={a}/>), 
                            resolve: res, 
                            reject: rej
                          });
                        })).then(result => {
                          modalContext.modal!();
                        }).catch(err => {});
                      }}
                    >
                      <MiniMediaViewer filename={a}/>
                    </span>
                  ))
                }
              </Gallery3>
            </div>
        }


        

        {
          (!!(eventReviews?.length)) && 
          <div className="p-4 rounded shadow-md bg-gradient-to-br from-fuchsia-100 via-fuchsia-200 to-fuchsia-100">
            <h1 className="p-4">Reviews for this event</h1>
            <div className="text-center">
              {
                eventReviews.map((er, i) => (
                  <span key={i}>
                    <ReviewComponent  reviewerName={er.name} reviewText={er.text} rating={er.stars} date={new Date()} />
                  </span>
                ))
              }
            </div>
          </div>
        }


        <div className="p-4 rounded shadow-md bg-gradient-to-br from-fuchsia-100 via-fuchsia-200 to-fuchsia-100">
          <h1 className="p-4">Write a review for this event</h1>
          <ReviewForm eventID={event.id}></ReviewForm>
        </div>

      </div>

    </div>
  );
};

export default EventFull;
